import * as React from 'react';
import styled from 'styled-components';
import { SInputLabel } from '../../integrationOnboarding/inputGroup/style';
import Radio, { IRadioOptionsProps } from './Radio';
import { ITheme } from '@sunbit-dev/ui/src/components/themes/online';

// tslint:disable-next-line:variable-name
const SRadioGroup = styled.section<{ direction: string }>(
  ({ theme, direction }) => `
  display: flex;
  flex-direction: ${direction};
  margin-right: ${theme}
`
);

const SRadioLabel = styled(SInputLabel)(
  ({ theme }: { theme: ITheme }) => `
    padding-bottom: 10px;
    padding-top: 30px;
`
);

// tslint:disable-next-line:variable-name
const SRadio = styled(Radio as any)(({ theme }) => ({
  marginBottom: theme.spacing.medium,
  marginRight: theme.spacing.large,
})) as unknown as new <T>() => Radio<T>;

// tslint:disable-next-line:no-empty-interface
export interface IRadioGroupProps<T> {
  name: string;
  direction?: 'row' | 'column';
  radioOptions: Array<IRadioOptionsProps<T>>;
  value: T;
  color?: string;
  onChange: (value: T, name: string) => void;
  dataAt?: string;
  dataTestId?: string;
  className?: string;
  labelClassName?: string;
  label?: string;
  disabled?: boolean;
}

export class RadioGroup<T> extends React.Component<IRadioGroupProps<T>> {
  public static defaultProps = {
    value: null,
    className: '',
    direction: 'column',
    labelClassName: '',
  };

  private handleOnClick = (value: T) => {
    this.props.onChange(value, this.props.name);
  };

  public render() {
    const { dataTestId, dataAt, disabled } = this.props;
    return (
      <>
        {this.props.label && <SRadioLabel className={this.props.labelClassName}>{this.props.label}</SRadioLabel>}
        <SRadioGroup direction={this.props.direction} className={this.props.className} data-at={this.props.dataAt}>
          {this.props.radioOptions.map((radioOption, index) => (
            <SRadio<T>
              disabled={disabled}
              dataAt={`${dataAt}_${radioOption.value}`}
              dataTestId={radioOption.dataTestId || `${dataTestId}_${radioOption.value}`}
              color={this.props.color || 'primaryLight'}
              key={index}
              {...radioOption}
              onClick={this.handleOnClick}
              selected={this.props.value === radioOption.value}
            />
          ))}
        </SRadioGroup>
      </>
    );
  }
}
